module.exports = __webpack_public_path__ + "static/media/icon_parking.8c14c36f.svg";